export class CostApproachLayout {
	public sections = [
		{
			title: 'General',
			items: [
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisType',
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisCostServiceQualityRatingDescription'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisDataSourceDescription'
						}
					},
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisEffectiveDate',
							displayType: 'date'
						}
					}
				],
				[
					{
						cssClass: 'col-md-3',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisEstimatedRemainingEconomicLifeYearsCount',
							displayType: 'years'
						}
					},
					{
						cssClass: 'col-md-9',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisEstimatedValueComment'
						}
					},
				]
			]
		},
		{
			title: 'Cost Worksheet',
			items: [
				[
					{
						cssClass: 'col-md-12',
						type: 'static-table',
						options: {
							header: [
								{ 
									label: 'Site Value',
									colSpan: 4
								},
								{ 
									label: 'Amount',
									cssClass: 'text-right'
								}
							],
							rows: [
								{
									cols: [
										{
											colSpan: 4,
											options: { 
												label: 'Opinion of Site Value'
											}
										},
										{
											cssClass: 'text-right',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisSiteEstimatedValueAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cssClass: 'sub-headers',
									cols: [
										{
											options: {  label: 'Improvement' }
										},
										{
											options: {  label: 'Description' }
										},
										{
											options: {  label: 'SqFt' }
										},
										{
											cssClass: 'text-right',
											options: {  label: 'Price per SqFt' }
										},
										{
											cssClass: 'text-right',
											options: {  label: 'Sub-Total' }
										},
									]
								},
								{
									cols: [
										{ options: { label: 'Dwelling' } },
										{ options: { label: '' } },
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisDwellingSquareFeetCount',
												displayType: 'gla',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											cssClass: 'text-right',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisDwellingPricePerSquareFootAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											cssClass: 'text-right',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisDwellingCostAmount',
												displayType: 'currency',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								},
								{
									cols: [
										{ options: { label: 'Other' } },
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisTypeOtherDescription',
												show: { label: false }
											}
										},
										{
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisOtherSquareFeetCount',
												displayType: 'gla',
												show: { label: false }
											}
										},
										{
											cssClass: 'text-right',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisOtherPricePerSquareFootAmount',
												displayType: 'currency',
												show: { label: false }
											}
										},
										{
											cssClass: 'text-right',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisOtherCostAmount',
												displayType: 'currency',
												show: { label: false }
											}
										}
									]
								},
								{
									cols: [
										{ options: { label: 'Additional' } },
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisAdditionalCostDescription',
												show: { label: false }
											}
										},
										{
											colSpan: 2,
											options: { label: '' }
										},
										{
											cssClass: 'text-right',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisAdditionalCostAmount',
												displayType: 'currency',
												show: { label: false }
											}
										}
									]
								},
								{
									cols: [
										{ 
											colSpan: 2,
											options: { label: 'Garage/Carport' }
										},
										{ 
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisGarageSquareFeetCount',
												displayType: 'gla',
												show: { label: false }
											}
										},
										{
											cssClass: 'text-right',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisGaragePricePerSquareFootAmount',
												displayType: 'currency',
												show: { label: false }
											}
										},
										{
											cssClass: 'text-right',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisGarageCostAmount',
												displayType: 'currency',
												show: { label: false }
											}
										}
									]
								},
								{
									cols: [
										{
											colSpan: 4,
											options: { label: 'Total Cost' }
										},
										{
											cssClass: 'text-right',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisNewImprovementTotalCostAmount',
												displayType: 'currency',
												show: { label: false }
											}
										}
									]
								},
								{
									cssClass: 'sub-headers',
									cols: [
										{
											colSpan: 4,
											options: {  label: 'Depreciation' }
										},
										{
											cssClass: 'text-right',
											options: {  label: 'Amount' }
										},
									]
								},
								{
									cols: [
										{
											colSpan: 4,
											options: { label: 'Physical' }
										},
										{
											cssClass: 'text-right',
											options: {
												cssClass: 'text-danger',
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisDepreciationPhysicalAmount',
												displayType: 'currency',
												show: { label: false }
											}
										}
									]
								},
								{
									cols: [
										{
											colSpan: 4,
											options: { label: 'Functional' }
										},
										{
											cssClass: 'text-right',
											options: {
												cssClass: 'text-danger',
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisDepreciationFunctionalAmount',
												displayType: 'currency',
												show: { label: false }
											}
										}
									]
								},
								{
									cols: [
										{
											colSpan: 4,
											options: { label: 'Exterior' }
										},
										{
											cssClass: 'text-right',
											options: {
												cssClass: 'text-danger',
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisDepreciationExteriorAmount',
												displayType: 'currency',
												show: { label: false }
											}
										}
									]
								},
								{
									cssClass: 'sub-headers',
									cols: [
										{
											colSpan: 3,
											options: {  label: '' }
										},
										{
											options: {  label: 'TOTALS' }
										},
										{
											options: {  label: '' }
										},
									]
								},
								{
									cols: [
										{
											colSpan: 3,
											options: {  label: '' }
										},
										{
											options: {  label: 'Total Depreciation' }
										},
										{
											cssClass: 'text-right text-danger',
											options: {
												cssClass: 'text-danger',
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisDepreciationTotalAmount',
												displayType: 'currency',
												show: { label: false }
											}
										}
									]
								},
								{
									cols: [
										{
											colSpan: 3,
											options: {  label: '' }
										},
										{
											options: {  label: 'Depreciated Cost Of Improvements' }
										},
										{
											cssClass: 'text-right',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisDepreciatedCostAmount',
												displayType: 'currency',
												show: { label: false }
											}
										}
									]
								},
								{
									cols: [
										{
											colSpan: 3,
											options: {  label: '' }
										},
										{
											options: {  label: 'As-Is Value of Site Improvements' }
										},
										{
											cssClass: 'text-right',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisSiteOtherImprovementsAsIsAmount',
												displayType: 'currency',
												show: { label: false }
											}
										}
									]
								},
								{
									cols: [
										{
											colSpan: 3,
											options: {  label: '' }
										},
										{
											cssClass: 'font-weight-bold',
											options: {  label: 'Indicated Value by Cost Approach' }
										},
										{
											cssClass: 'text-right font-weight-bold',
											options: {
												path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisValueIndicatedByCostApproachAmount',
												displayType: 'currency',
												show: { label: false }
											}
										}
									]
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Comments on Cost Approach',
			items: [
				[
					{
						cssClass: 'col-md-12',
						type: 'field',
						options: {
							path: 'CV_EXTENSION_SECTION.FIELDS.CVCostAnalysisCommentOnCostApproach',
							show: {
								label: false
							}
						}
					}
				]
			]
		}
	];
}